import {
    isInRange,
} from "../editor/utils";

const searchInAlignment = (srcData, textToSearch, slots, id, alignmentLength) => {
    const txtToSearch = textToSearch.toUpperCase()
    let result = [];
    let match;
    slots.forEach(s => {
        let count = 0;
        let pos = 0;
        while ((pos = srcData.indexOf(txtToSearch, count)) > -1) {
            match = {
                pos: s.start + pos,
                id: id
            }

            if ((s.start + pos) >= 0 && (s.start + pos) <= alignmentLength) {
                result.push(match);
            }
            count = pos + 1
        }
    })

    return result;
}

const renderInitialShift = (shiftLength) => {
    let shift = "";
    for (let i = 0; i < shiftLength; i++) {
        shift += " "
    }
    return shift;
}

const maxChromatograms = (chromatograms) => {
    let max = 0;
    for (let key in chromatograms) {
        chromatograms[key].forEach(a => {
            if (a) {
                const tmpMax = Math.max(...a);
                max = Math.max(max, tmpMax)
            }
        });
    }
    return max;
}

const setChromatogramPaths = (chromatograms) => {
    const chromatogramPath = {};
    let chromatogramPaths = [];
    let tmpMaxHeight = 0;
    let maxHeight = 0;
    Object.entries(chromatograms).forEach(([key]) => {
        chromatogramPath[key] = [];
        [chromatogramPaths, tmpMaxHeight] = splitChromatogram(chromatograms[key]);

        maxHeight = Math.max(maxHeight, tmpMaxHeight)
        chromatogramPath[key].push(chromatogramPaths);
    })

    return [chromatogramPath, maxHeight];
}

const splitReferenceData = (temp_start, temp_end, data) => {
    const slots = [];
    const temp_referenceLength = data.length + temp_start;
    let start = temp_start;
    if (temp_start) {
        slots.push({
            start: 0,
            end: temp_start,
            length: start
        })
    }

    for (let i = start; i <= temp_referenceLength; i++) {
        if (data[i] === '-' || i === temp_referenceLength) {
            const slot = {
                start: start,
                end: i,
                length: i - start
            }
            if (start !== i) {
                slots.push(slot)
            }
            start = i + 1;
        }
    }

    if (temp_end !== temp_referenceLength) {
        slots.push({
            start: temp_referenceLength,
            end: temp_referenceLength + temp_end,
            length: temp_end
        })
    }

    return slots
}

const getRedundantReferenceMatchingPatterns = (position, offset, referenceMatchingPatterns) => {
    return referenceMatchingPatterns.filter((rm) => {
        return offset < 0 ? rm.start >= position : rm.end <= position;
    }).map(r => {
        return {
            ...r,
            start: r.start + offset,
            end: r.end + offset,
        }
    });
}

const alignRedundantReferenceMatchingPatterns = (offsetStart, offsetEnd, referenceMatchingPatterns, referenceLength) => {
    const preRedundantMatchingPatterns = getRedundantReferenceMatchingPatterns(referenceLength - offsetStart, -(referenceLength - offsetStart), referenceMatchingPatterns);
    const postRedundantMatchingPatterns = getRedundantReferenceMatchingPatterns(offsetEnd, referenceLength + offsetStart, referenceMatchingPatterns);
    const fixedMatchingPatterns = referenceMatchingPatterns.map(r => {
        return {
            ...r,
            start: r.start + offsetStart,
            end: r.end + offsetStart,
        }
    })
    return [...preRedundantMatchingPatterns, ...fixedMatchingPatterns, ...postRedundantMatchingPatterns];
}

const redundantAnnotations = (offsetStart, offsetEnd, annotations, referenceLength, alignmentLength) => {
    const redundant = [];

    annotations.forEach(a => {
        a.start += offsetStart;
        a.end += offsetStart;

        if (a.start > a.end) {
            a.end += referenceLength
        }

        a.origin_start = a.start;
        a.origin_end = a.end;

        if (isInRange(a.start, a.end, referenceLength, referenceLength + offsetStart)) {
            let redundantAnnotation = {...a};
            redundantAnnotation.start = a.start - referenceLength < 0 ? 0 : a.start - referenceLength;
            redundantAnnotation.end = a.end - referenceLength;

            redundantAnnotation.origin_start = a.start - referenceLength;
            redundantAnnotation.origin_end = a.end - referenceLength;

            redundantAnnotation.direction = !a.hasOwnProperty("amino_sequence") && a.direction === 2 && a.start - referenceLength < 0 ? 0 : a.direction;
            redundantAnnotation.redundant = 1;
            redundant.push(redundantAnnotation);

            if (a.end > alignmentLength) {
                if (isInRange(a.end - offsetStart - referenceLength, a.end - offsetStart - referenceLength, referenceLength - offsetStart, referenceLength)) {
                    redundantAnnotation = {...a};
                    redundantAnnotation.start = 0;
                    redundantAnnotation.end = (a.end - referenceLength - offsetStart) - (referenceLength - offsetStart);

                    redundantAnnotation.origin_start = a.end - (a.end - a.start);
                    redundantAnnotation.origin_end = a.end + referenceLength;

                    redundantAnnotation.direction = a.direction === 2 && !a.hasOwnProperty("amino_sequence") ? 0 : a.direction;
                    redundantAnnotation.redundant = 2;
                    redundant.push(redundantAnnotation);
                }
                a.end = alignmentLength;
                a.direction = a.hasOwnProperty("amino_sequence") ? a.direction : 0;
            }

            if (isInRange(a.start, a.end, offsetStart, offsetStart + offsetEnd)) {
                redundantAnnotation = {...a};
                redundantAnnotation.start = a.start - (2 * referenceLength);
                redundantAnnotation.end = a.end - (2 * referenceLength);

                redundantAnnotation.origin_start = a.start - (2 * referenceLength);
                redundantAnnotation.origin_end = a.end - (2 * referenceLength);

                redundantAnnotation.direction = !a.hasOwnProperty("amino_sequence") && a.direction === 1 && a.end + referenceLength > alignmentLength ? 0 : a.direction;
                redundantAnnotation.redundant = 3;

                redundant.push(redundantAnnotation);
            }


        } else if (isInRange(a.start, a.end, offsetStart, offsetStart + offsetEnd)) {
            const redundantAnnotation = {...a};
            redundantAnnotation.start = a.start + referenceLength;
            redundantAnnotation.end = a.end + referenceLength > alignmentLength ? alignmentLength : a.end + referenceLength;

            redundantAnnotation.origin_start = redundantAnnotation.start;
            redundantAnnotation.origin_end = a.end + referenceLength;

            redundantAnnotation.direction = !a.hasOwnProperty("amino_sequence") && a.direction === 1 && a.end + referenceLength > alignmentLength ? 0 : a.direction;
            redundantAnnotation.redundant = 4;

            redundant.push(redundantAnnotation)

        }
    })
    return redundant;
}

const redundantMatchingPatterns = (offsetStart, offsetEnd, matchingPatterns, referenceLength, alignmentLength) => {
    const redundant = [];
    matchingPatterns.forEach(m => {
        m.start = m.start + offsetStart;
        m.end = m.end + offsetStart;
        if (isInRange(m.start, m.end, referenceLength, referenceLength + offsetStart)) {
            let redundantMatchingPattern = {...m};
            redundantMatchingPattern.start = m.start - referenceLength;
            redundantMatchingPattern.end = m.end - referenceLength;
            redundant.push(redundantMatchingPattern)
        } else if (isInRange(m.start, m.end, offsetStart, offsetStart + offsetEnd)) {
            let redundantMatchingPattern = {...m};
            redundantMatchingPattern.start = m.start + referenceLength;
            redundantMatchingPattern.end = m.end + referenceLength;
            redundant.push(redundantMatchingPattern)
        }
    });
    return redundant;
}

const stretchAminoAcids = (codingSequences, insertionMatchingPatterns) => {
    codingSequences.forEach(a => {
        const aminoSequence = a.amino_sequence.split("");
        let start = a.origin_start;
        let end = start;
        let stretchedAminoAcids = [];
        const stretchedAminoSequencePositions = [];

        aminoSequence.forEach((amino, index) => {
            if (insertionMatchingPatterns.length) {
                const insertionLength = matchingPatternInsertionLength(start, (start + 3), insertionMatchingPatterns);
                end += 3 + (insertionLength ? insertionLength : 0);

                stretchedAminoAcids.push(amino);
                stretchedAminoSequencePositions.push([start, end - start]);
                start = end;
            }
        });

        if (stretchedAminoAcids.length === 0) {
            start = a.start;
            aminoSequence.forEach((amino) => {
                stretchedAminoAcids.push([amino]);
                stretchedAminoSequencePositions.push([start, 3]);
                start += 3;
            });
        }
        a.steched_amino_sequence = stretchedAminoAcids;
        a.steched_amino_sequence_positions = stretchedAminoSequencePositions;
    });
}

const matchingPatternInsertionLength = (start, end, array) => {
    let count = 0;
    let insertionLength = 0;
    do {
        if (isInRange(start, end, array[count].start, array[count].end)) {
            insertionLength = array[count].length
        }

        count++;
    } while (count < array.length && !insertionLength)

    return insertionLength;
}

const splitChromatogram = (data) => {
    const slots = [];
    let start = 0;
    let tmpSlotPath = [];
    let tempChromotogram = [];
    let positionX = 0;
    const length = data.length;
    let maxHeight = 0;
    for (let i = 0; i <= length; i++) {
        if ((data[i] !== undefined && data[i][0] === null) || i === length) {
            const slot = {
                start: start,
                end: i,
                length: i - start,
                path: tmpSlotPath
            }
            if (start !== i) {
                slots.push(slot)
            }
            positionX = 0;
            tmpSlotPath = []
            start = i + 1;
        } else {
            tempChromotogram = [];
            for (let p = 0; p < 3; p++) {
                maxHeight = Math.max(maxHeight, data[i][p])
                const pos = [
                    positionX + (p === 1 ? data[i][3] : p / 2),
                    data[i][p],
                ]
                tempChromotogram.push(pos)
            }
            positionX += 1
            tmpSlotPath.push(tempChromotogram)
        }
    }
    return [slots, maxHeight]
}


const rangeSlice = (slotStart, slotEnd, chromatogramLength, edgeLeft, edgeRight) => {
    let startPath = 0;
    let sliceLength;

    if (slotStart >= edgeLeft && slotEnd <= edgeRight) {
        sliceLength = chromatogramLength;
    } else if (edgeLeft < slotStart) {
        sliceLength = edgeRight - slotStart
    } else if (edgeRight > slotEnd) {
        startPath = edgeLeft - slotStart
        sliceLength = slotEnd - edgeLeft
    } else {
        startPath = edgeLeft - slotStart
        sliceLength = edgeRight - edgeLeft
    }

    return [startPath, sliceLength];
}

const histogramPath = (dataArray, height, stepHistogram, fontBoxWidth) => {
    let path = [];
    let x;
    let y;
    dataArray.forEach((c, i) => {
        for (let posChar = 0; posChar <= 3; posChar++) {
            x = (i + stepHistogram)
            y = -(1 + (c * height))
            if (posChar === 0 || posChar === 3) {
                y = -1
            }
            if (posChar === 2 || (posChar === 3)) {
                x = (i + 1 - stepHistogram)
            }
            path.push([x * fontBoxWidth, y])
        }
    })
    return path;
}

const identityColor = (identityHeight, maxHeight) => {
    let color = "red";
    if (identityHeight >= (maxHeight / 2)) {
        color = identityHeight > (maxHeight / 100) * 90 ? "green" : "yellow";
    }
    return color
}

const getMatchingPatterns = (startRead, startTrim, endRead, endTrim, mismatches = [], deletions = [], insertions = [], offsetStart = 0) => {
    let matchingPatterns;
    const firstTrim = [];
    const lastTrim = [];

    if (startTrim) {
        firstTrim.push(
            {
                start: startRead - startTrim + offsetStart,
                end: startRead + offsetStart,
                length: startTrim,
                type: "trim"
            });
    }

    const tempMismatches = mismatches.map(ms => ({
        start: ms[0] + offsetStart,
        end: ms[1] + offsetStart,
        length: ms[1] - ms[0],
        type: "mis",
    }));

    const tempDeletions = deletions.map(d => ({
        start: d[0] + offsetStart,
        end: d[1] + offsetStart,
        length: d[1] - d[0],
        type: "del",
    }));

    const tempInsertions = insertions.map(i => ({
        start: i[0] + offsetStart,
        end: i[1] + offsetStart,
        length: i[1] - i[0],
        type: "ins",
    }));

    if (endTrim) {
        lastTrim.push(
            {
                start: endRead + offsetStart,
                end: endRead + endTrim + offsetStart,
                length: endTrim,
                type: "trim"
            });
    }
    matchingPatterns = [...firstTrim, ...tempMismatches, ...tempDeletions, ...tempInsertions, ...lastTrim].sort((a, b) => a.start - b.start)
    return matchingPatterns;
}

const alignmentLength = (referenceLength, reads) => {
    reads.forEach(r => {
        referenceLength = Math.max(referenceLength, r.end + r.end_trim)
    })
    return referenceLength
}

const alignmentSizes = (referenceLength, reads) => {
    let alignmentLength = referenceLength;
    let maxChromatogramHeightReads = 0;
    let maxQualityValueReads = 0;
    let readCount = 0;
    let start_alignment = 0;
    let end_alignment = 0;
    reads.forEach(r => {
        if (r.successful) {
            if ((r.end + r.end_trim) > referenceLength) {
                start_alignment = Math.max(referenceLength - (r.start - r.start_trim), start_alignment);
                end_alignment = Math.max((r.end + r.end_trim) - referenceLength, end_alignment);
            }
            alignmentLength = Math.max(alignmentLength, referenceLength + start_alignment + end_alignment)
            maxQualityValueReads = Math.max(maxQualityValueReads, ...r.quality_values)
            readCount++;
        }
    })
    return [alignmentLength, start_alignment, end_alignment, maxChromatogramHeightReads, maxQualityValueReads, readCount]
}

const getBasePairs = (basePairs, slots, startSelection, endSelection) => {
    let count = 0;
    let ret = "";
    do {
        if (isInRange(startSelection, endSelection, slots[count].start, slots[count].end)) {
            if (startSelection < slots[count].start) {
                startSelection = slots[count].start;
            }
            if (endSelection > slots[count].end) {
                endSelection = slots[count].end;
            }
            return basePairs.substring(startSelection - slots[count].start, endSelection - slots[count].start)
        }
        count++;
    } while (count < slots.length && !ret.length);
    return ret;
}

export {
    searchInAlignment,
    renderInitialShift,
    maxChromatograms,
    alignRedundantReferenceMatchingPatterns,
    redundantAnnotations,
    redundantMatchingPatterns,
    stretchAminoAcids,
    setChromatogramPaths,
    splitReferenceData,
    rangeSlice,
    identityColor,
    getMatchingPatterns,
    histogramPath,
    alignmentLength,
    alignmentSizes,
    getBasePairs
}